import { mainSiteUrl } from "@/mocks/categories";
import { homepageContent } from "@/mocks/articles";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20setup%20with%20laptop%20displaying%20organized%20product%20spreadsheet%20data%20on%20screen%2C%20surrounded%20by%20curated%20shopping%20items%20including%20sneakers%2C%20leather%20accessories%20and%20fragrance%20bottles%20arranged%20aesthetically%20on%20warm%20wooden%20surface%2C%20natural%20morning%20light%20streaming%20through%20window%2C%20sage%20green%20and%20warm%20cream%20color%20palette%2C%20editorial%20product%20photography%2C%20soft%20atmospheric%20shadows%2C%20aspirational%20lifestyle%20aesthetic%2C%20organized%20yet%20lived-in%20feel%2C%20professional%20ecommerce%20discovery%20workspace&width=1600&height=900&seq=hero-vigorbuy-v2&orientation=landscape"
          alt="Vigorbuy Spreadsheet product discovery platform with curated shopping items"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-24 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-3xl mx-auto">
          {homepageContent.heroTitle}
        </h1>
        <p className="mt-6 text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
          {homepageContent.heroSubtitle}
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            {homepageContent.heroCtaPrimary}
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white font-semibold text-sm rounded-full border border-white/30 hover:bg-white/25 transition-all duration-300 whitespace-nowrap"
          >
            {homepageContent.heroCtaSecondary}
          </a>
        </div>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-white/75 text-xs">
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
            Updated Product Guides
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
            Organized Categories
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
            Beginner Friendly
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
            Secure Shopping Tips
          </span>
        </div>
      </div>
    </section>
  );
}